import { Injectable, inject } from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {AuthentificationService} from '../services/authentification.service';
import {JwtService} from '../services/jwt.service';

@Injectable()
export class AuthGuard  {
    private authService = inject(AuthentificationService);
    router = inject(Router);
    private jwtService = inject(JwtService);


    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ) {
        if (this.authService.isLogin) {
            return true;
        }

        if (
            !this.jwtService.isTokenExpired(this.authService.token) ||
            this.authService.refreshToken
        ) {
            this.router.navigate(
                ['/connexion/load-user'], {
                state: {
                    previousRoute: { url: state.url }
                }
            });
            return false;
        } else {
            this.router.navigate(['/connexion'], {
                state: {
                    previousRoute: { url: state.url }
                }
            });
            return false;
        }
    }
}
